<template>
    <div class="row bank_id_verification">
        <div class="col-12">
            <div class="panel-sub-heading headingLarge">
                <span class="h5 display-6 markedBottom bold">{{ lang('bank_id_verification') }}</span>
                <p>{{ lang('bank_id_message') }}</p>
            </div>
        </div>
        <div class="col-12 d-flex flex-wrap">
            <template v-for="bankid_option in verificationOptions">
                <a class="btn btn-md btn-secondary" :class="{'selected': bankid_option.value === modelValue}"
                        @click="verifyWithBankId(bankid_option, owner)" data-original-title=""
                        title="">{{ bankid_option.label }}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import * as types from "../stores/constants";
import {NPRadios} from "netpify/components";

export default {
    name: "bank-id-verify",
    components: {
        'np-radios': NPRadios,
    },
    props: {
        acrValuesOptions: {
            default() {
                return []
            },
            type: Array,
        },
        principal_index: 0,
        modelValue: '',
        owner: '',
        application_reference: '',
        owner_ref: '',
        parameters: {
            default() {
                return []
            }
        }
    },
    data() {
        return {
            // value: '',
        }
    },
    computed: {
        verificationOptions: function () {
            let options = this.jsonCopy(this.acrValuesOptions).map(obj => {
                let label = this.lang('verify_with_bank_id') + ': ' + obj.label;
                obj.text = label;
                obj.label = label;
                return obj;
            });
            options.push({label: this.lang('verify_with_document_upload'), value: 'DOCUMENT', bankid_acr_value: '',})
            return options;
        }
    },
    methods: {
        verifyWithBankId: function (bankid_option, owner) {
            if (this.modelValue !== `DOCUMENT` && owner.is_bank_id_verified == '1'){
                let reminder_text = this.lang('lose_the_previously_saved_bank_details_alert').replace('{0}', owner.owner_first_name);
                reminder_text = reminder_text.replace('{1}', owner.owner_surname)
                this.$swal({
                    // Alert! This will clear your verification of principal_first_name principal_Last_name, are you sure you want to continue? - Yes/No
                    title: this.lang('bank_verification_alert'),
                    text: reminder_text,
                    icon: "warning",
                    confirmButtonColor: '#e64942',
                    showCancelButton: true,
                    confirmButtonText: this.lang('field_yes'),
                    cancelButtonText:this.lang('field_no'),
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    },
                    dangerMode: true,
                })
                .then((selected_option) => {
                    if (selected_option) {
                        owner.is_bank_id_verified = '0';
                        this.doBankVerification(bankid_option)
                    }
                });
            }
            else {
                this.doBankVerification(bankid_option)
            }
        },
        doBankVerification: function(bankid_option) {
            let vm = this;
            this.$emit('update:modelValue', bankid_option.value);
            this.$emit('input', bankid_option.value);

            let exist_my_language = vm.$parent && vm.$parent.$parent && vm.$parent.$parent.$parent
                && vm.$parent.$parent.$parent.$parent && !!(vm.$parent.$parent.$parent.$parent.my_language);
            let current_language = !!exist_my_language ? vm.$parent.$parent.$parent.$parent.my_language.split('_')[0] : '';

            let current_action = window.location.pathname.split('/')[2];

            if (bankid_option.bankid_acr_value !== '' && this.objectIsNotEmpty(this.parameters)) {
                let criipto_param = this.parameters;
                let acr_value = bankid_option.bankid_acr_value;
                let redirect_uri = site_url + 'application/bankidverify/';
                // let bank_id_verify_base_ulr = 'https://technologiworldwide-test.criipto.id/oauth2/authorize';
                let params = {
                    'response_type': criipto_param.response_type,
                    'response_mode': criipto_param.response_mode,
                    'client_id': criipto_param.client_id,
                    'redirect_uri': redirect_uri,
                    'acr_values': acr_value,  //'urn:grn:authn:no:bankid'
                    'scope': 'openid',
                    'ui_locales': current_language,
                    'state': this.application_reference + '_' + vm.owner_ref + '_' + current_action + '__' + bankid_option.value,
                };
                let params_string = Object.keys(params).map(key => key + '=' + params[key]).join('&');
                window.location.href = criipto_param.bank_id_authorise_url + '?' + params_string;
            }
        },
    }
}
</script>

<style scoped>

</style>